import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from "./../store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  routes: [
    //Dashboards
    {
      path: "/",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "Dashboard",
          path: "/",
          beforeEnter: authorizationGuard,
          meta: { title: "Anasayfa", authorize: [] },
          component: () => {
            // Safe access to role list
            const roles = store.state.auth.userRoleList || [];

            if (roles.indexOf("OysOgrenci") >= 0) {
              return import("@/views/dashboards/StudentDashboard");
            } else if (roles.indexOf("OysOkutman") >= 0) {
              return import("@/views/dashboards/LecturerDashboard");
            } else if (
              roles.indexOf("OysAdmin") >= 0 ||
              roles.indexOf("OysEgitimKoordinatör") >= 0 ||
              roles.indexOf("OysMerkezKoordinatör") >= 0
            ) {
              return import("@/views/dashboards/ControlPanel");
            } else if (roles.indexOf("MuhasebeAdmin") >= 0 || roles.indexOf("MuhasebeUser") >= 0) {
              return import("@/views/orders/StudentOrders");
            } else {
              // alert("Role Redirect Error: No matching dashboard found for roles: " + JSON.stringify(roles));
              router.push({ name: "Error" });
            }
          },
        },
        {
          name: "Order",
          path: "/orders",
          component: () => import("@/views/orders/Order"),
          beforeEnter: authorizationGuard,
          meta: { title: "Siparişlerim", authorize: ["OysOgrenci"] },
        },

        {
          name: "StudentOrders",
          path: "/siparisler",
          component: () => import("@/views/orders/StudentOrders"),
          beforeEnter: authorizationGuard,
          meta: { title: "Tüm Siparişler", authorize: ["OysAdmin", "MuhasebeUser", "MuhasebeAdmin"] },
        },
        {
          name: "Project",
          path: "/proje-islemleri",
          component: () => import("@/views/project/Project"),
          beforeEnter: authorizationGuard,
          meta: { title: "Proje İşlemleri", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },

        {
          name: "Zoom",
          path: "/ders-islem/cevrimici-ders",
          component: () => import("@/views/zoom/Zoom"),
          beforeEnter: authorizationGuard,
          meta: { title: "Çevrimiçi Ders", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },

        {
          name: "ActiveLessons",
          path: "/ders-islem/aktif-dersler",
          component: () => import("@/views/class-zoom/ClassZoom"),
          beforeEnter: authorizationGuard,
          meta: { title: "Aktif Dersler", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "DersDevamsizlik",
          path: "/ders-devamsizlik",
          component: () => import("@/views/curriculum/Curriculum"),
          beforeEnter: authorizationGuard,
          meta: { title: "Ders / Devamsızlık", authorize: ["OysOgrenci"] },
        },
        {
          name: "CenterPerson",
          path: "/merkez-islemleri/merkez-personel-islemleri",
          component: () => import("@/views/center-person/CenterPerson"),
          beforeEnter: authorizationGuard,
          meta: { title: "Merkez / Personel", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "AddCenterPerson",
          path: "/merkez-islemleri/personel-ekle",
          component: () => import("@/views/center-person/AddCenterPerson"),
          beforeEnter: authorizationGuard,
          meta: { title: "Personel Ekle / Düzenle", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "Yoklama",
          path: "/ogrenci-isleri/yoklama-islemleri",
          component: () => import("@/views/attendance/Attendance"),
          beforeEnter: authorizationGuard,
          meta: { title: "Yoklama", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "Puanlama",
          path: "/ogrenci-isleri/puan-islemleri",
          component: () => import("@/views/score/Score"),
          beforeEnter: authorizationGuard,
          meta: { title: "Puanlama", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        //Sınıf İşlemleri
        {
          name: "ClassList",
          path: "/sinif-islemleri/aktif-siniflar",
          component: () => import("@/views/class/ClassList"),
          beforeEnter: authorizationGuard,
          meta: { title: "Sınıf İşlemleri", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "Tamamlanmış Sınıflar",
          path: "/sinif-islemleri/tamamlanmis-siniflar",
          component: () => import("@/views/class/InactiveClassList"),
          meta: { title: "Sınıf İşlemleri", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "StudentList",
          path: "/ogrenci-isleri/ogrenci-islemleri",
          component: () => import("@/views/student/StudentList"),
          beforeEnter: authorizationGuard,
          meta: { title: "Öğrenci İşlemleri", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "OrderedStudentList",
          path: "/ogrenci-isleri/ucretli-ogrenci-islemleri",
          component: () => import("@/views/student/StudentPaymentList"),
          beforeEnter: authorizationGuard,
          meta: { title: "Öğrenci Ödeme İşlemleri", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "StudentFinder",
          path: "/ogrenci-isleri/ogrenci-bul",
          component: () => import("@/views/student/StudentFind"),
          beforeEnter: authorizationGuard,
          meta: { title: "Öğrenci Bul", authorize: ["OysAdmin"] },
        },
        {
          name: "StudentListByClassId",
          path: "/siniftaki-ogrenciler/:classId",
          component: () => import("@/views/student/StudentList"),
          beforeEnter: authorizationGuard,
          meta: { title: "Öğrenci İşlemleri", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "StudentDetails",
          path: "/ogrenci-islemleri/:studentId",
          component: () => import("@/views/student/StudentDetails"),
          beforeEnter: authorizationGuard,
          meta: { title: "Öğrenci Detay", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },

        {
          name: "AddStudent",
          path: "ogrenci-isleri/ogrenci-ekle",
          component: () => import("@/views/student/AddStudent"),
          beforeEnter: authorizationGuard,
          meta: { title: "Öğrenci Ekle", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },

        {
          name: "StudentProfile",
          path: "/ogrenci-profili/:studentId",
          component: () => import("@/views/student/StudentProfile"),
          beforeEnter: authorizationGuard,
          meta: { title: "Öğrenci Profili", authorize: ["OysOgrenci"] },
        },
        {
          name: "ClassTemplate",
          path: "/sinif-islemleri/sinif-sablon",
          component: () => import("@/views/class-template/ClassTemplate"),
          beforeEnter: authorizationGuard,
          meta: { title: "Sınıf Şablonları", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },

        //Sertifika ve Katılım Belgeleri
        {
          name: "EvaluateCertificates",
          path: "/belge-islemleri/degerlendirme",
          component: () => import("@/views/certificate/EvaluateCertificates"),
          beforeEnter: authorizationGuard,
          meta: { title: "Değerlendirme Aşaması", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "Certificates",
          path: "/belge-islemleri/sertifika-islemleri",
          component: () => import("@/views/certificate/Certificates"),
          beforeEnter: authorizationGuard,
          meta: { title: "Sertifika İşlemleri", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "StudentCertificates",
          path: "/sertifikalarim",
          component: () => import("@/views/certificate/StudentCertificates"),
          beforeEnter: authorizationGuard,
          meta: { title: "Sertifikalarım", authorize: ["OysOgrenci"] },
        },
        {
          name: "ParticipantCertificates",
          path: "/belge-islemleri/katilim-belgesi-islemleri",
          component: () => import("@/views/certificate/Participations"),
          beforeEnter: authorizationGuard,
          meta: { title: "Katılım Belgesi İşlemleri", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "Centers",
          path: "/merkez-islemleri/merkez-donem-islemleri",
          component: () => import("@/views/settings/centers/Centers"),
          beforeEnter: authorizationGuard,
          meta: { title: "Merkez Dönem İşlemleri", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
      ],
    },
    //Auth
    {
      path: "/",
      component: () => import("@/layouts/form-layout/FormLayout"),
      children: [
        {
          name: "Login",
          path: "login",
          component: () => import("@/views/authentication/Login"),
          meta: { title: "Giriş Yap", authorize: [] },
        },
        {
          name: "Confirm",
          path: "confirm",
          component: () => import("@/views/authentication/Confirm"),
          meta: { title: "Onay", authorize: [] },
        },
      ],
    },

    //Form Ekranı
    {
      path: "/kayit",
      component: () => import("@/layouts/form-layout/FormLayout"),
      children: [
        {
          //Form Path
          path: "/",
          component: () => import("@/views/form/Form"),
          name: "Form",
          meta: { title: "Kayıt", authorize: [] },
        },
      ],
    },

    //Raporlar
    {
      path: "/raporlar",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { title: "Rapolar", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
      beforeEnter: authorizationGuard,
      children: [
        {
          name: "GeneralReports",
          path: "genel-raporlar",
          component: () => import("@/views/reports/GeneralReports"),
          beforeEnter: authorizationGuard,
          meta: { title: "Raporlar -> Genel Raporlar", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "Lecturer",
          path: "okutman-raporlari",
          component: () => import("@/views/reports/lecturer/LecturerReports"),
          beforeEnter: authorizationGuard,
          meta: { title: "Raporlar -> Okuman Raporları", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "CertificateReports",
          path: "ulke-raporu",
          component: () => import("@/views/reports/CountryReport"),
          beforeEnter: authorizationGuard,
          meta: { title: "Raporlar -> Ülke Bazlı Öğrenci Repo", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "CountryReport",
          path: "sertifika-raporlari",
          component: () => import("@/views/reports/certificates/CertificatesReports"),
          beforeEnter: authorizationGuard,
          meta: { title: "Raporlar -> Sertifika Raporları", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
      ],
    },

    //Form Ayarları
    {
      path: "/ayarlar/form-ayarlar",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { title: "Form Ayarları", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
      beforeEnter: authorizationGuard,
      children: [
        {
          name: "FormStatus",
          path: "form-durumu",
          component: () => import("@/views/settings/form-settings/form-status/FormStatus"),
          beforeEnter: authorizationGuard,
          meta: { title: "Form -> Form Durumu Ayarları", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "Job",
          path: "meslek",
          component: () => import("@/views/settings/form-settings/job/Job"),
          beforeEnter: authorizationGuard,
          meta: { title: "Form -> Meslek Ayarları", authorize: ["OysAdmin"] },
        },
        {
          name: "ApplicationPurpose",
          path: "basvuru-amaci",
          component: () => import("@/views/settings/form-settings/application-purpose/ApplicationPurpose"),
          beforeEnter: authorizationGuard,
          meta: { title: "Form -> Başvuru Amacı Ayarları", authorize: ["OysAdmin"] },
        },
      ],
    },

    //ayarlar
    {
      path: "/ayarlar",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { title: "Genel Ayarlar", authorize: ["OysAdmin"] },
      beforeEnter: authorizationGuard,
      children: [
        {
          name: "EventStudentMessageStatus",
          path: "ogrenci-mesaj-durum",
          component: () => import("@/views/settings/event-message-status/EventStudentMessageStatus"),
          beforeEnter: authorizationGuard,
          meta: { title: "Ayarlar -> Mesaj Durum", authorize: ["OysAdmin"] },
        },
        {
          name: "ClassStatus",
          path: "sinif-durum",
          component: () => import("@/views/settings/class-status/ClassStatus"),
          beforeEnter: authorizationGuard,
          meta: { title: "Ayarlar -> Sınıf Durum", authorize: ["OysAdmin"] },
        },
        {
          name: "EventActions",
          path: "etkinlik-aksiyon-mesajlari",
          component: () => import("@/views/settings/event-actions/EventAction"),
          beforeEnter: authorizationGuard,
          meta: { title: "Ayarlar -> Etkinlik Aksiyon", authorize: ["OysAdmin"] },
        },
        {
          name: "ClassTypes",
          path: "sinif-turleri",
          component: () => import("@/views/settings/class-type/ClassType"),
          beforeEnter: authorizationGuard,
          meta: { title: "Ayarlar -> Sınıf Türleri", authorize: ["OysAdmin"] },
        },
      ],
    },

    //Videolar
    {
      path: "/video",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { title: "Video", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör", "OysOgrenci"] },
      beforeEnter: authorizationGuard,
      children: [
        {
          name: "VideoList",
          path: "liste",
          component: () => import("@/views/video/list/Video"),
          beforeEnter: authorizationGuard,
          meta: { title: "Video İşlemleri", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },

        {
          name: "VideoList",
          path: "listeogrenciokutman",
          component: () => import("@/views/video/list/VideoStudentTeacher"),
          beforeEnter: authorizationGuard,
          meta: { title: "Video İşlemleri", authorize: ["OysAdmin", "OysOkutman", "OysOgrenci"] },
        },

        {
          name: "VideoList",
          path: "calmalistesi",
          component: () => import("@/views/video/playlist/Playlist"),
          beforeEnter: authorizationGuard,
          meta: { title: "Çalma Listesi", authorize: ["OysAdmin", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },

        {
          name: "VideoList",
          path: "calmalistesiogrenciokutman",
          component: () => import("@/views/video/playlist/PlaylistStudentTeacher"),
          beforeEnter: authorizationGuard,
          meta: { title: "Çalma Listesi", authorize: ["OysAdmin", "OysOkutman", "OysOgrenci"] },
        },

        {
          name: "VideoCategory",
          path: "kategori",
          component: () => import("@/views/video/category/VideoCategory"),
          beforeEnter: authorizationGuard,
          meta: { title: "Video Kategori", authorize: ["OysAdmin"] },
        },
      ],
    },

    //Etkinlikler
    {
      path: "/etkinlik",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { title: "Etkinlik", authorize: ["OysOgrenci", "OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
      beforeEnter: authorizationGuard,
      children: [
        {
          name: "EventList",
          path: "liste",
          component: () => import("@/views/events/Event"),
          beforeEnter: authorizationGuard,
          meta: { title: "Etkinlik İşlemleri", authorize: ["OysOgrenci", "OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
        {
          name: "EventCategory",
          path: "kategori",
          component: () => import("@/views/events/eventCategory/EventCategory"),
          beforeEnter: authorizationGuard,
          meta: { title: "Etkinlik Kategori", authorize: ["OysAdmin"] },
        },
        {
          name: "EventType",
          path: "tip",
          component: () => import("@/views/events/eventType/EventType"),
          beforeEnter: authorizationGuard,
          meta: { title: "Etkinlik Tipi", authorize: ["OysAdmin"] },
        },
      ],
    },

    //Etkinlik Mesajlar
    {
      path: "/etkinlik-detay",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { title: "Etkinlik Detay", authorize: ["OysOgrenci", "OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
      beforeEnter: authorizationGuard,
      children: [
        {
          name: "EventDetails",
          path: ":eventId",
          beforeEnter: authorizationGuard,
          meta: { title: "Etkinlik Detay", authorize: [] },
          component: () => {
            if (store.state.auth.userRoleList.indexOf("OysOgrenci") >= 0) {
              return import("@/views/events/eventMessages/EventStudentMessages");
            } else if (
              store.state.auth.userRoleList.indexOf("OysOkutman") >= 0 ||
              store.state.auth.userRoleList.indexOf("OysEgitimKoordinatör") >= 0 ||
              store.state.auth.userRoleList.indexOf("OysMerkezKoordinatör") >= 0 ||
              store.state.auth.userRoleList.indexOf("OysAdmin") >= 0
            ) {
              return import("@/views/events/eventMessages/EventLecturerMessages");
            } else {
              router.push({ name: "Error" });
            }
          },
        },
      ],
    },

    //Duyurular
    {
      path: "/duyuru",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { title: "Duyuru", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
      beforeEnter: authorizationGuard,
      children: [
        {
          name: "NoticeList",
          path: "liste",
          component: () => import("@/views/notice/Notice"),
          beforeEnter: authorizationGuard,
          meta: { title: "Duyuru İşlemleri", authorize: ["OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },

        {
          name: "NoticeType",
          path: "tip",
          component: () => import("@/views/notice/noticeType/NoticeType"),
          beforeEnter: authorizationGuard,
          meta: { title: "Duyuru Tipi", authorize: ["OysAdmin"] },
        },

        {
          name: "NoticeDetails",
          path: ":noticeId",
          component: () => import("@/views/notice/NoticeDetails"),
          beforeEnter: authorizationGuard,
          meta: { title: "Duyuru Detay", authorize: ["OysOgrenci", "OysAdmin", "OysOkutman", "OysMerkezKoordinatör", "OysEgitimKoordinatör"] },
        },
      ],
    },
    {
      name: "CertificateValidate",
      path: "/belge-islemleri/dogrulama/:id",
      component: () => import("@/views/certificate/CertificateValidate"),
      meta: { title: "Doğrulama Aşaması" },
    },
    {
      path: "*",
      name: "Error",
      component: () => import("@/views/authentication/Error"),
      meta: { title: "Hata", authorize: [] },
    },

    //Payment Recovery (Admin)
    {
      path: "/admin",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { title: "Yönetici İşlemleri", authorize: ["OysAdmin"] },
      beforeEnter: authorizationGuard,
      children: [
        {
          name: "PaymentRecovery",
          path: "payment-recovery",
          component: () => import("@/views/payment/PaymentRecovery"),
          beforeEnter: authorizationGuard,
          meta: { title: "Eksik Ödeme Kurtarma", authorize: ["OysAdmin"] },
        },
      ],
    },

    //Sözleşme İşlemleri
    {
      path: "/contracts",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { title: "contracts", authorize: ["OysAdmin"] },
      beforeEnter: authorizationGuard,
      children: [
        {
          name: "ContractAdd",
          path: "contract",
          component: () => import("@/views/contracts/contract/ContractAdd"),
          beforeEnter: authorizationGuard,
          meta: { title: "Sözleşme Ekle", authorize: ["OysAdmin"] },
        },
      ],
    },
  ],
});

import { authorizationGuard } from "../utils/authorize-guard";

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    store.dispatch("clearPagination");
  }
  next();
});

const DEFAULT_TITLE = "Yunus Emre Enstitüsü";
router.afterEach((to) => {
  // Complete the animation of the route progress bar.
  setTimeout(() => {
  }, 1200);

  Vue.nextTick(() => {
    document.title = "Yunus Emre Enstitüsü | " + to.meta.title || DEFAULT_TITLE;
  });
});
export default router;
